import { render, staticRenderFns } from "./VeeTextarea.vue?vue&type=template&id=4130e067&"
import script from "./VeeTextarea.vue?vue&type=script&lang=js&"
export * from "./VeeTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports